import React, { useEffect, useState } from "react";
import FormikControl from "../../../../components/FormikControls/FormikControl";
import {
  Box,
  Typography,
  Button,
  IconButton
} from "@mui/material";
import { Formik, Form } from "formik";
import { createIndexManagingSchema } from "../../StaticData/index";
import MultiSelect from "../../../../components/FormikControls/MultiSelect/MultiSelect";
import { useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import AccordionLyt from "../../../../components/Layouts/AccordionLyt/AccordionLyt";
import { CreateIndexManagingFace } from "../../Interfaces/Interfaces";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import DyLoadingCircular from "../../../../components/GlobalComponents/DyLoadingCircular/DyLoadingCircular";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import Exeloo from "./exeloo.svg";
import axios from 'axios';

import {
  useCreateIndexManaging,
} from "../../Hooks/Index";
import { baseUrl } from "../../../../env";

const UploadFile = ({
  periodsData,
  onSuccess,
  perId,
  bauData,
  setShowToastMessage2,
  setObjectiveAsyncOpState,
  afterSuccess,
  access,
  getAgain,
  onClose
}: any) => {
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const personId=useSelector((state:any)=>state.loign.personId);
  const userId=useSelector((state:any)=>state.loign.userInfo.userId);
  
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [file, setFile] = useState(null);
  const [data, setData] = useState<any>();

  const handleFileChange = (e : any) => {
    setFile(e.target.files[0]);
  };

//   const handleUpload = async () => {
//     if (!file) return;

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       const response = await axios.post(`${baseUrl}upload/UploadIndexExcel`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       setData(response.data);
//     } catch (error) {
//       console.error('Error uploading the file:', error);
//     }
//   };

const handleUpload = async () => {
    if (!file) return;
  
    const formData = new FormData();
    formData.append('file', file);
    // formData.append('tenantId',tenantId ); 
  
    try {
      const response = await axios.post(`${baseUrl}upload/UploadIndexExcel`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Parameter-TenantId':tenantId,
          'X-Parameter-PersonId':personId,
          'X-Parameter-UserId':userId,
        },
      });
      setData(response.data);
    } catch (error) {
      console.error('Error uploading the file:', error);
    }finally{
        getAgain();
    }
  };

  useEffect(() => {
    if (data !== undefined &&  data > 0) {
      //if (data) {
        setShowToastMessage2(true);
        SetIsSuccess(true);
        SetTMessage('data');
        onSuccess();
        //onClose(false);
        const timer = setTimeout(() => {
            onClose(false);
          }, 3000);
      
          // پاک کردن تایمر در صورت لغو یا تغییر
          return () => clearTimeout(timer);
        }
    //   } else {
    //     setShowLtoastMessage(true);
    //     SetIsSuccess(false);
    //     SetTMessage('');
    //   }
    }
  , [data]);

  return (
    <>
      {/* <Box width={"100%"} maxHeight={"50em"} padding={2}>
      <IconButton
                  color="info"
                  onClick={() => {
                  }}
                >
                  <Box>
                    <Link
                      target="_blank"
                      to={`${baseUrl}Download/GetIndexTemplate`}
                    >
                      <img
                        src={Exeloo}
                        style={{ height: 28, width: 30 }}
                        alt="exelLogo"
                      />
                    </Link>
                    </Box>
                    دریافت نمونه اکسل
      </IconButton>
      <div>
      <input type="file" onChange={handleFileChange} accept=".xlsx, .xls" />
      <button onClick={handleUpload}>ارسال</button>

      <div>
        <h3>نام فایل:</h3>
        <pre>{JSON.stringify(data, null, 2)}</pre>
      </div>
     </div> */}

<Box width="100%" maxHeight="50em" padding={3} sx={{ backgroundColor: "#f5f5f5", borderRadius: 2, boxShadow: 1 }}>
  <Box display="flex" alignItems="center" mb={2}>
  <IconButton
                  color="info"
                  onClick={() => {
                  }}
                >
                  <Box>
                    <Link
                      target="_blank"
                      to={`${baseUrl}Download/GetIndexTemplate`}
                    >
                        دریافت نمونه اکسل
                      <img
                        src={Exeloo}
                        style={{ height: 28, width: 30 }}
                        alt="exelLogo"
                      />
                    </Link>
                    </Box>
      </IconButton>
  </Box>

  <Box display="flex" flexDirection="column" alignItems="center">
    <input 
      type="file" 
      onChange={handleFileChange} 
      accept=".xlsx, .xls"
      style={{ marginBottom: 10, padding: '6px 12px', border: '1px solid #ccc', borderRadius: 4 }}
    />
    <Button 
      variant="contained" 
      color="primary" 
      onClick={handleUpload}
      sx={{ width: '50%', fontSize: '0.9em' }}
    >
      ارسال
    </Button>
  </Box>

  <Box mt={3}>
    <Typography variant="h6">تعداد درج موفق:</Typography>
    <Box component="pre" sx={{ backgroundColor: "#eee", padding: 2, borderRadius: 1, overflowX: "auto" }}>
      {JSON.stringify(data, null, 2)}
    </Box>
  </Box>
</Box>

        {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
    </>
  );
};

export default UploadFile;